import axios from 'axios'
import {isEmpty} from 'lodash'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteGrievanceModal} from '../Model'
import {ServiceTypeModel} from '../Model/ServiceTypeModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const SERVICE_TYPE = `${API_URL}/grievance`

// Columns the API returns in the export file but that should not reach the CSV
const EXCLUDED_EXPORT_COLUMNS = [
  'service category',
  'service type',
  'service sub type',
  'assigned to',
  'assigned to department',
  'assigned department',
  'account no',
  'account no.',
  'account number',
  'preferred branch',
  'prefered branch',
]

const isExcludedColumn = (header: string) => {
  const name = header?.trim().toLowerCase()
  return EXCLUDED_EXPORT_COLUMNS.includes(name)
}

// Minimal quote-aware CSV parser - fields may hold commas, newlines and escaped quotes
const parseCsv = (text: string): string[][] => {
  const rows: string[][] = []
  let row: string[] = []
  let field = ''
  let inQuotes = false

  for (let i = 0; i < text.length; i++) {
    const char = text[i]

    if (inQuotes) {
      if (char === '"') {
        if (text[i + 1] === '"') {
          field += '"'
          i++
        } else {
          inQuotes = false
        }
      } else {
        field += char
      }
      continue
    }

    if (char === '"') {
      inQuotes = true
    } else if (char === ',') {
      row.push(field)
      field = ''
    } else if (char === '\n' || char === '\r') {
      if (char === '\r' && text[i + 1] === '\n') {
        i++
      }
      row.push(field)
      rows.push(row)
      row = []
      field = ''
    } else {
      field += char
    }
  }

  if (field.length > 0 || row.length > 0) {
    row.push(field)
    rows.push(row)
  }

  return rows
}

const escapeCsvField = (field: string) =>
  /[",\r\n]/.test(field) ? `"${field.replace(/"/g, '""')}"` : field

const dropExcludedColumns = (csv: any) => {
  if (typeof csv !== 'string' || isEmpty(csv.trim())) {
    return csv
  }

  const rows = parseCsv(csv)
  const header = rows[0]

  if (isEmpty(header)) {
    return csv
  }

  const keptIndexes = header
    .map((column, index) => (isExcludedColumn(column) ? -1 : index))
    .filter((index) => index !== -1)

  // header names did not match - hand back the original file untouched
  if (keptIndexes.length === header.length) {
    return csv
  }

  return rows
    .map((row) => keptIndexes.map((index) => escapeCsvField(row[index] ?? '')).join(','))
    .join('\r\n')
}

export const service = {
  getGrievance: (params: ParamsModel) => {
    return axios.get(SERVICE_TYPE, {params})
  },
  deleteGrievance: (data: DeleteGrievanceModal) => {
    return axios.delete(`${SERVICE_TYPE}/bulk-delete`, {data})
  },

  //export file
  exportGrievanceFile: (fileName: string, params: ParamsModel) => {
    return axios.get(`${SERVICE_TYPE}/export`, {params}).then((response) => {
      const blob = new Blob([dropExcludedColumns(response?.data)])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.csv`) //or any other extension
      document.body.appendChild(link)
      link.click()
    })
  },
}
